/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';

import { BuilderSharedModule } from '@gh/builder-shared';
import { TodoRestService } from '@gh/builder-shared-data';

import { BuilderTodoRoutingModule } from './builder-todo-routing.module';

import {
  MutateTodoDialogComponent,
  PassTodoDialogComponent,
  SettingsPanelControlComponent,
  TodoListComponent,
  ToDoListNoRowsOverlayComponent,
  TodoTypeMenuComponent,
} from './components';
import { TodoListBusinessService } from './resources';

@NgModule({
  imports: [
    BuilderSharedModule.forChild(),
    BuilderTodoRoutingModule,
  ],
  declarations: [
    TodoListComponent,
    MutateTodoDialogComponent,
    PassTodoDialogComponent,
    SettingsPanelControlComponent,
    TodoTypeMenuComponent,
    ToDoListNoRowsOverlayComponent,
  ],
  providers: [
    TodoListBusinessService,
    TodoRestService,
  ],
})
export class BuilderTodoModule {
}
